import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import InnerHTML from 'dangerously-set-html-content';

export const StyledCustom = ({ id, bleed, content }) => {
	return <Custom id={id} bleed={bleed === 'on'} content={content} />;
};

StyledCustom.propTypes = {
	id: PropTypes.string,
	bleed: PropTypes.string,
	content: PropTypes.string,
};

export const Custom = ({ id, bleed, content }) => {
	useEffect(() => {}, [content]);

	if (!content) {
		return null;
	}

	return (
		<div id={id} className={bleed ? 'bleed' : null}>
			<InnerHTML html={content} />;
		</div>
	);
};

Custom.propTypes = {
	id: PropTypes.string.isRequired,
	bleed: PropTypes.bool,
	content: PropTypes.string,
};

Custom.defaultProps = {
	bleed: false,
};
